/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import cx from 'classnames';
import { usePrefix } from '../../internal/usePrefix.js';
import '../Text/index.js';
import { Text } from '../Text/Text.js';

function ListItem(_ref) {
  let {
    className,
    children,
    ...other
  } = _ref;
  const prefix = usePrefix();
  const classNames = cx(`${prefix}--list__item`, className);
  return /*#__PURE__*/React__default.createElement(Text, _extends({
    as: "li",
    className: classNames
  }, other), children);
}
ListItem.propTypes = {
  /**
   * Specify the content for the ListItem
   */
  children: PropTypes.node,
  /**
   * Specify an optional className to apply to the underlying `<li>` node
   */
  className: PropTypes.string
};

export { ListItem as default };
